/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { NameValueTuple } from "../../models/name-value-tuple";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetDnssecAlgorithms$Params {}

export function getDnssecAlgorithms(
  http: HttpClient,
  rootUrl: string,
  params?: GetDnssecAlgorithms$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<NameValueTuple>>> {
  const rb = new RequestBuilder(rootUrl, getDnssecAlgorithms.PATH, "get");
  if (params) {
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameValueTuple>>;
    }),
  );
}

getDnssecAlgorithms.PATH = "/surfdomeinen/info/dnssec_algorithms";
